/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Error_No_ActiveInputs */

const vi_trip_error_no_active = /** @type {(inputs: Trip_Error_No_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có chuyến đang chạy`)
};

/**

* @param {Trip_Error_No_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_error_no_active = /** @type {((inputs?: Trip_Error_No_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Error_No_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_error_no_active(inputs)
});